export default "__VITE_ASSET__JvjV8Cbx__"